import HttpClient from './httpClient';

class UserFilesAndFoldersController extends HttpClient {
  createFolder = async (folder, token) => {
    const response = await this.client.post('/createFolder', folder, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  createFile = async (file, token) => {
    const response = await this.client.post('/createFile', file, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  getDocs = async (tag, token) => {
    const response = await this.client.get(`/drive/${tag}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  getFolderData = async (nodeId, token) => {
    const response = await this.client.get(`/folder/${nodeId}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  shareItems = async (data, token) => {
    const response = await this.client.post(`/shareItems`, data, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  acceptSharedItems = async (data, token) => {
    const response = await this.client.get(`/acceptShared/${data}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  trash = async (data, token) => {
    const response = await this.client.put('/trash', data, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  makeACopy = async (nodeId, token) => {
    const response = await this.client.get(`/makeACopy/${nodeId}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  uploadWisedocFiles = async (selectedFiles, token) => {
    const response = await this.client.post(
      `/uploadWisedocFiles`,
      selectedFiles,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  };

  moveItem = async (data, token) => {
    const response = await this.client.post(`/moveItem`, data, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  renameItem = async (data, token) => {
    const response = await this.client.put('/renameItem', data, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  untag = async (data, token) => {
    const response = await this.client.post('/untag', data, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  permissions = async (nodeId, token) => {
    const response = await this.client.get(`/permissions/${nodeId}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  changeAccess = async (data, token) => {
    const response = await this.client.post('/changeAccess', data, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  getFileData = async (nodeId, token) => {
    const response = await this.client.get(`/getDoc/${nodeId}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  checkEditAccess = async (nodeId, token) => {
    const response = await this.client.get(`/checkAccess/${nodeId}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  getSharePermissions = async (nodeData, token) => {
    const response = await this.client.post(`/getSharePermissions`, nodeData, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  resendInvite = async (data, token) => {
    const response = await this.client.post(`/resendInvite`, data, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };
}

export default new UserFilesAndFoldersController(
  process.env.REACT_APP_API_BASE_URL_FOLDER_STRUCTURE,
);
